export default () => ({
  errors: [],
  has_error: false,
  stype: "error",
})
